import React, { useState } from 'react';
import { getAnalytics, logEvent } from "firebase/analytics";
import { Graph, LoadingSpinner } from "./Graph"
import { Modal } from "./Modal"
import { IoChevronBackOutline, IoHelpOutline } from "react-icons/io5";

import axios from 'axios';
import './index.css';
import './App.css';
import {app} from './firebase.js';

const analytics = getAnalytics(app);

function SearchForm(props){

  const [choice, setChoice] = useState(null);

  function handleSearch(e) {
    e.preventDefault();
    logEvent(analytics, 'search', { address: props.address})
    props.setStatus("loading")
    if (choice === "dd") {
      axios.get('https://us-central1-dddyor.cloudfunctions.net/getBalance?address='+props.address)
      .then(response => {
        props.setResult(response.data)
        if (response.data.status === "1")
        {
          props.setStatus("dd-result")
        } else {
          props.setStatus("dd-error")
        }
      }).catch(e => {
        console.log(e)
        props.setStatus("dd-error")
      });
    } else {
      axios.get('https://us-central1-dddyor.cloudfunctions.net/getBalanceAndTransactions?address='+props.address)
      .then(response => {
        props.setResult(response.data.result)
        if (response.data.status === "1")
        {
          props.setResult(response.data)
          props.setStatus("dyor-result")
        } else {
          props.setStatus("dd-error")
        }
      }).catch(e => {
        console.log(e)
        props.setStatus("dd-error")
      });
    }
  }

  return <div className='flex flex-col m-auto'>
            <h1 className="flex-row text-center text-5xl mb-5">
              Enter Ethereum Address
            </h1>
            <form onSubmit={handleSearch} className='flex flex-col mx-2'>
              <input onChange={e => props.setAddress(e.target.value)} value={props.address} className='flex-row border-b-black border-b font-thin' placeholder='0x0000000000000000000000000000000000000000'>
              </input>
              <button onClick={()=> setChoice("dyor")} className='flex-row grow-0 text-center mt-5 p-3 border border-transparent hover:border-black rounded-md' type="submit">
                DYOR (Do Your Own Research) -{'>'}
              </button>
              <button onClick={()=> setChoice("dd")} className='flex-row grow-0 text-center p-3 border border-transparent hover:border-black rounded-md'>
                DD (Due Diligence) -{'>'}
              </button>
            </form>
            <div className='mt-10 text-center'>
              Inspired by this <a href='https://twitter.com/0x_Jonas/status/1482248994332250112' target="_blank" rel="noopener noreferrer" className='border-b-black border-b'>tweet</a> 
            </div>
            </div>
}

function NavBar(props){

  function handleHowToModal(){
    props.setHowToModalData({
      title: "How DDDYOR works",
      content: <div>
                <p className='mb-4'>First step: Enter address or ens to search</p>
                <p className='font-bold'>DYOR</p>
                <p> Start a search from an addresss and create your own graph</p>
                <p> List on the right are the trasaction addresses</p>
                <li> Click 🔎 to search for ens or contract name, </li>
                <p> (<span className='text-red-700'>Red name -{'>'} contract</span> , <span className='text-sky-700'>Blue name -{'>'} ENS</span>)</p>
                <li> Click + to add new node and their transaction history to the graph</li>
                <p> (Red <span className='text-red-500'>+</span> means that the node is already on the graph)</p>
                <p className='mb-4'> You can drag the nodes around, click on a node will start another search from that node</p>
                <p className='font-bold'>DD</p>
                <p className='mb-4'> Get a list of sites where you can do your due diligence</p>
                <p> Have fun!</p>
               </div>,
      action: <div>
                  <button onClick={()=>props.setShowHowToModal(false)} className='w-1/5 py-3 rounded-lg border border-black hover:border-b-2 hover:border-r-2'>Got it</button>
                  <button onClick={()=>window.open("https://forms.gle/VMi7WtVCTYZfKd947")} className='ml-3 w-1/5 py-3 rounded-lg border border-black hover:border-b-2 hover:border-r-2'>
                   Send Us Feedback
                  </button>
              </div>
    })
    props.setShowHowToModal(true)
  }

  let backButton = <button onClick={() => props.setStatus(null)} className='w-20 m-auto'>
                    <IoChevronBackOutline size={"2rem"} className={"m-auto p-1 rounded-full hover:border-black hover:border"}/>
                   </button>

  return <div className='flex'>
            {props.status ? backButton : <div className='w-20'></div>}
            <h1 onClick={() => props.setStatus(null)} className="flex-grow text-center py-3 cursor-pointer">
              DDDYOR
            </h1>
            <button onClick={() => handleHowToModal()} className='w-20 text-center'>
                <IoHelpOutline size={"2rem"} className={"m-auto p-1 rounded-full hover:border-black hover:border"}/>
            </button>
          </div>
}

function Result(props){

  let addressBalance = Math.round(parseInt(props.result.balance)/(10**14))/10000

  return <div>
          <div className='text-center'>
            <h1 className="flex-row flex-grow overflow-x-auto overflow-y-hidden text-center text-5xl mt-6 mb-2">
              {props.address}
            </h1>
            <h2 className="flex-row flex-grow overflow-x-auto overflow-y-hidden text-center text-5xl my-2">
            {props.status === "dd-result" && "Eth - " + addressBalance}
            </h2>
            {props.status === "dd-error" && <h2 className='text-red-500'>{props.result.balance}</h2>}
            <div className=' mb-6'>Reference: <a href='https://twitter.com/0x_Jonas/status/1482248994332250112' target="_blank" rel="noopener noreferrer" className='border-b-black border-b'> this tweet</a> </div>
          </div>
          <div className="h-full grid lg:grid-cols-3">
            {props.status === "dd-error" && <button onClick={() => props.setStatus(null)} className='lg:col-start-2 lg:col-end-2 font-thin'> Back </button>}
            {props.status === "dd-result" &&
                <div className='lg:col-start-2 lg:col-end-2 flex-grow mb-3 px-5 lg:px-0'>
                  <ul>
                  <li className='flex-row text-center font border border-black rounded-lg py-3 mb-3 hover:border-b-2 hover:border-r-2 cursor-pointer'
                        onClick={()=> window.open("https://etherscan.io/address/"+props.result.address, "_blank")}> 
                        Etherscan 
                    </li>
                    <li className='flex-row text-center font border border-black rounded-lg py-3 mb-3 hover:border-b-2 hover:border-r-2 cursor-pointer'
                        onClick={()=> window.open("https://app.ens.domains/address/"+props.result.address, "_blank")}> 
                        ENS 
                    </li>
                    <li className='flex-row text-center font border border-black rounded-lg py-3 mb-3 hover:border-b-2 hover:border-r-2 cursor-pointer'
                        onClick={()=> window.open("https://apeboard.finance/dashboard/"+props.result.address, "_blank")}> 
                        Ape Board 
                    </li>
                    <li className='flex-row text-center font border border-black rounded-lg py-3 mb-3 hover:border-b-2 hover:border-r-2 cursor-pointer'
                        onClick={()=> window.open("https://app.cyberconnect.me/address/"+props.result.address, "_blank")}> 
                        CyberConnect
                    </li>
                    <li className='flex-row text-center font border border-black rounded-lg py-3 mb-3 hover:border-b-2 hover:border-r-2 cursor-pointer'
                        onClick={()=> window.open("https://nftscan.com/search/"+props.result.address, "_blank")}> 
                        NFTSCAN
                    </li>
                    <li className='flex-row text-center font border border-black rounded-lg py-3 mb-3 hover:border-b-2 hover:border-r-2 cursor-pointer'
                        onClick={()=> window.open("https://beta.prysm.xyz/profile/"+props.result.address+"/overview", "_blank")}> 
                        Prysm
                    </li>
                    <li className='flex-row text-center font border border-black rounded-lg py-3 mb-3 hover:border-b-2 hover:border-r-2 cursor-pointer'
                        onClick={()=> window.open("https://ethplorer.io/address/"+props.result.address, "_blank")}> 
                        Ethplorer
                    </li>
                    <li onClick={()=> props.setStatus(null)} className='flex-row text-center font border border-white rounded-lg py-3 mb-3 hover:border-slate-200 hover:border-b-2 hover:border-r-2 cursor-pointer'>
                      {'<'}-
                    </li>
                  </ul>
                  
                </div>
            }
          </div>
        </div>
}



function App() {

  const [status, setStatus] = useState(null);
  const [address, setAddress] = useState("");
  const [result, setResult] = useState(null);
  const [showModal, setShowModal] = useState(false)
  const [modalData, setmodalData] = useState({
                                                  title: "",
                                                  content: "",
                                                  action: ""
                                              })

  let page;
  switch(status) {
    case "loading":
      page = <LoadingSpinner></LoadingSpinner>
      break;
    case "dd-result":
      page = <Result address={address} status={status} result={result} setStatus={setStatus}></Result>
      break;
    case "dd-error":
      page = <Result address={address} status={status} result={result} setStatus={setStatus}></Result>
      break;
    case "dyor-result":
      page = <Graph address={address} status={status} result={result} setStatus={setStatus} setShowModal={setShowModal} setModalData={setmodalData}></Graph>
    break;
    default:
      page = <SearchForm setStatus={setStatus} address={address} setAddress={setAddress} setResult={setResult}></SearchForm>
  }

  return (
    <div className="flex flex-col h-screen font-mono">
      {showModal && <Modal setShowModal={setShowModal} modalData={modalData}></Modal>}
      <NavBar status={status} setStatus={setStatus} setShowHowToModal={setShowModal} setHowToModalData={setmodalData}></NavBar>
      {page}
    </div>
  );
}

export default App;
